import { Module }       from 'vuex';
import { RootState }    from '@/store/store.types';
import state, { State } from '@/views/settings/store/settings.state.store';
import actions          from '@/views/settings/store/settings.actions.store';
import mutations        from '@/views/settings/store/settings.mutations.store';
import getters          from '@/views/settings/store/settings.getters.store';

const store: Module<State, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};

export default store;
